import getInvitedUserDetailsApi from '../apiCalls/users/getInvitedUserDetails.api.js';

export default function* getUserDetailsFromUserToken(userToken) {
  const response = yield getInvitedUserDetailsApi({ userToken });
  return response?.data ?? {};
}
